<script lang="ts" setup>
import CommunityButton from '@/components/common/buttons/CommunityButton.vue'
import RewardsIcon from '@/components/common/icons/RewardsIcon.vue'
import { app } from '@/composition/app'
import { GroupState } from '@/composition/groups'
import {
  UIDivider,
  UITextMdMedium,
  UITextSmNormal,
  UITextXsRegular,
} from '@gohighlevel/ghl-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
<template>
  <div class="flex h-container w-full flex-col">
    <div
      v-if="
        GroupState.state.groupData?.settings?.gamificationSettings?.rewards &&
        GroupState.state.groupData?.settings?.gamificationSettings?.rewards
          .length > 0
      "
      class="mt-5 h-full px-4"
    >
      <div class="flex flex-col gap-5">
        <div
          v-for="reward in GroupState.state.groupData?.settings
            ?.gamificationSettings?.rewards"
          :key="reward.title"
        >
          <UITextMdMedium
            id="reward-title"
            class="text-communities-sidebar-font-primary"
          >
            {{ reward.title }}</UITextMdMedium
          >
          <UITextSmNormal
            id="reward-description"
            class="mt-1.5 text-communities-sidebar-font-primary"
          >
            {{ reward.description }}</UITextSmNormal
          >
        </div>
      </div>
    </div>
    <div
      v-else
      class="flex h-full flex-col items-center justify-center text-communities-sidebar-font-primary"
    >
      <RewardsIcon class="h-16 w-16" />
      <UITextXsRegular class="mt-3">{{
        t('leaderboard.rewardsWillBeDisplayedHere')
      }}</UITextXsRegular>
    </div>
    <div v-if="GroupState.state.isGroupAdmin" class="flex w-full flex-col">
      <UIDivider />
      <CommunityButton
        id="sme"
        class="mx-4 mb-4 uppercase"
        button-type="primary"
        @click="app.openGroupSettings('GamificationAndRewards')"
        >+ {{ t('leaderboard.addRewards') }}</CommunityButton
      >
    </div>
  </div>
</template>

<style scoped>
.n-divider:not(.n-divider--vertical) {
  margin-top: 16px;
  margin-bottom: 16px;
  --n-color: var(--sidebar-border) !important;
}
.n-divider:not(.n-divider--dashed) .n-divider__line {
  background-color: var(--sidebar-border);
}
</style>
